import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Autocomplete,
  Box,
  Card,
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment
} from '@mui/material';
import { NotificationManager } from 'react-notifications';
import { isMobile } from 'react-device-detect';

import {
  CustomGrid,
  CustomInfosForm,
  TextareaAutosize
} from '../../../../assets/style/globalStyle';
import RenderPage from '../../../layouts/RenderPage';
import configAxios from '../../../../services/configAxios';
import { selectLogin } from '../../../../store/login/loginSlice';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import Iconify from '../../../../@core/theme/Iconify';
import InputMask from 'react-input-mask';
import { validateCNPJ, validateCPF } from '../../../../@core/utils/utilsFunctions';
import {
  parseCurrencyValue,
  calcMensalidadeBase,
  calcQuotationDiscounts,
  applyDiscountToPrice
} from '../../../../@core/utils/quotationDiscountUtils';

const CONTRACT_CODES = [
  // { code: '01', label: '1-INDIVIDUAL/FAMILIAR' },
  { code: '02', label: '2-COLETIVO EMPRESARIAL' },
  { code: '03', label: '3-COLETIVO POR ADESAO' }
];

const AddEditQuotation = (props) => {
  const navigation = useNavigate();
  const { state } = useLocation();
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const initialInfos = state?.infosEdit || {};
  const initialContractCode =
    initialInfos.contract_code ||
    CONTRACT_CODES.find((c) => c.label === initialInfos.tpcontrat_client)?.code ||
    '';

  const [infosQuotations, setInfosQuotations] = useState({
    id: initialInfos.id || undefined,
    codplano: initialInfos.codplano || '',
    labelplans: initialInfos.labelplans || '',
    codtab: initialInfos.codtab || '',
    labeltables: initialInfos.labeltables || '',
    contract_code: initialContractCode,
    hospital_pronto_socorro: initialInfos.hospital_pronto_socorro || '',
    hospital_internacao: initialInfos.hospital_internacao || '',
    coverage_promotional: initialInfos.coverage_promotional || '',
    id_user: initialInfos.id_user || infoState?.id || undefined,
    id_broker: initialInfos.id_broker || undefined,
    obs: initialInfos.obs || undefined,
    nome: initialInfos.nome || undefined,
    cpf_cnpj: initialInfos.cpf_cnpj || undefined
  });

  const [initialInfosQuotations] = useState({ ...initialInfos });

  const [contractType, setContractType] = useState(initialContractCode);
  const [infosPlansTemp, setInfosPlansTemp] = useState([]);
  const [infosTablesTemp, setInfosTablesTemp] = useState([]);
  const [infosBrokersTemp, setInfosBrokersTemp] = useState([]);
  const [rangeValues, setRangeValues] = useState([]);
  const [savedValues, setSavedValues] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState({});

  const [coparticipation, setCoparticipation] = useState({
    hospital_pronto_socorro: initialInfos.hospital_pronto_socorro || '',
    hospital_internacao: initialInfos.hospital_internacao || '',
    amb_consulta_valor: initialInfos.amb_consulta_valor || '',
    amb_consulta_percent: initialInfos.amb_consulta_percent || '',
    amb_proced_baixo_valor: initialInfos.amb_proced_baixo_valor || '',
    amb_proced_baixo_percent: initialInfos.amb_proced_baixo_percent || '',
    amb_proced_medio_valor: initialInfos.amb_proced_medio_valor || '',
    amb_proced_medio_percent: initialInfos.amb_proced_medio_percent || '',
    amb_proced_alto_valor: initialInfos.amb_proced_alto_valor || '',
    amb_proced_alto_percent: initialInfos.amb_proced_alto_percent || ''
  });

  const [coveragePromotional, setCoveragePromotional] = useState(
    initialInfos.coverage_promotional || ''
  );

  const [coverageAcresc, setCoverageAcresc] = useState(initialInfos.coverage_acresc || '');

  useEffect(() => {
    if (initialInfos.id && initialContractCode && initialInfos.codplano) {
      const loadInitialData = async () => {
        try {
          const codcontratotpcontrat = initialContractCode;
          const response = await configAxios.get(
            `products/getPlansLabel/0/${codcontratotpcontrat}`
          );

          if (response.data && response.data.length > 0) {
            const plans = response.data
              .filter(
                (plan) =>
                  plan.codplano && plan.codplano !== '' && plan.codplano !== null && plan.id !== ''
              )
              .map((plan) => ({
                ...plan,
                label: plan.label || `${plan.codplano} - ${plan.descplano || ''}`,
                displayLabel: `${plan.label || plan.codplano} - ${
                  CONTRACT_CODES.find((c) => c.code === initialContractCode)?.label
                }`,
                contract_code: initialContractCode
              }));

            setInfosPlansTemp(plans);

            if (initialInfos.codplano) {
              configAxios
                .get('/tables/getTablesLabel/0')
                .then((tablesResponse) => {
                  const filteredTables = tablesResponse.data.filter(
                    (table) => table.codplano === initialInfos.codplano
                  );
                  setInfosTablesTemp(filteredTables);
                })
                .catch(() => {
                  NotificationManager.error(
                    'Tivemos dificuldades para buscar as tabelas de referência! Tente novamente.',
                    'Atenção'
                  );
                });
            }
          }
        } catch (error) {
          NotificationManager.error(
            'Tivemos dificuldades para buscar os planos! Tente novamente.',
            'Atenção'
          );
        }
      };

      loadInitialData();
    }
    loadBrokers();
  }, []);

  useEffect(() => {
    if (!contractType) {
      setInfosPlansTemp([]);
      setInfosQuotations((prev) => ({
        ...prev,
        codplano: '',
        labelplans: '',
        codtab: '',
        labeltables: '',
        contract_code: '',
        nome: '',
        cpf_cnpj: ''
      }));
      setInfosTablesTemp([]);
      return;
    }

    const isEditMode = initialInfos.id && initialContractCode;
    const contractTypeChanged = contractType !== initialContractCode;

    loadPlans();

    if (!isEditMode || contractTypeChanged) {
      setInfosQuotations((prev) => ({
        ...prev,
        codplano: '',
        labelplans: '',
        codtab: '',
        labeltables: '',
        contract_code: contractType,
        ...(contractTypeChanged
          ? {
              nome: '',
              cpf_cnpj: ''
            }
          : {})
      }));
      setInfosTablesTemp([]);
    } else {
      setInfosQuotations((prev) => ({
        ...prev,
        contract_code: contractType
      }));
    }
  }, [contractType]);

  useEffect(() => {
    if (!infosQuotations.codplano) {
      const isEditMode = initialInfos.id && initialInfos.codtab;
      if (!isEditMode) {
        setInfosTablesTemp([]);
        setInfosQuotations((prev) => ({ ...prev, codtab: '', labeltables: '' }));
      }
      return;
    }
    loadTables();
  }, [infosQuotations.codplano]);

  useEffect(() => {
    // Os valores já vêm junto com a cotação em initialInfos.values
    if (
      initialInfos.values &&
      Array.isArray(initialInfos.values) &&
      initialInfos.values.length > 0
    ) {
      setSavedValues(initialInfos.values);
    } else {
      setSavedValues([]);
    }
  }, [initialInfos.values]);

  useEffect(() => {
    if (!savedValues.length || !rangeValues.length) return;

    // Carregar valores salvos após as faixas serem definidas
    // Normalizar o formato da faixa_etaria para comparar corretamente
    setBeneficiaries((prev) => {
      const next = { ...prev };
      savedValues.forEach((item) => {
        if (item.faixa_etaria) {
          const normalizedFaixa = item.faixa_etaria.trim().replace(/\s+/g, ' ');
          const matchingRange = rangeValues.find((range) => {
            const rangeLabel = range.label.trim();
            return (
              rangeLabel === normalizedFaixa || rangeLabel.replace(/\s+/g, ' ') === normalizedFaixa
            );
          });
          if (matchingRange) {
            next[matchingRange.label] = item.qtdevidas ? String(item.qtdevidas) : '';
          }
        }
      });
      return next;
    });
  }, [savedValues, rangeValues]);

  // Atualizar estados quando initialInfos mudar (após salvar e recarregar)
  useEffect(() => {
    if (initialInfos.coverage_promotional !== undefined) {
      setCoveragePromotional(initialInfos.coverage_promotional || '');
    }
    if (initialInfos.coverage_acresc !== undefined) {
      setCoverageAcresc(initialInfos.coverage_acresc || '');
    }
    if (initialInfos.hospital_pronto_socorro !== undefined) {
      setCoparticipation((prev) => ({
        ...prev,
        hospital_pronto_socorro: initialInfos.hospital_pronto_socorro || '',
        hospital_internacao: initialInfos.hospital_internacao || ''
      }));
    }
  }, [
    initialInfos.coverage_promotional,
    initialInfos.hospital_pronto_socorro,
    initialInfos.hospital_internacao
  ]);

  // Buscar faixas etárias quando a tabela for selecionada
  useEffect(() => {
    if (infosQuotations.codtab) {
      loadRangeValues();
    } else {
      // Limpar faixas quando não houver tabela selecionada
      setRangeValues([]);
      setBeneficiaries({});
    }
  }, [infosQuotations.codtab]);

  const loadBrokers = () => {
    configAxios
      .get('/brokers/listBrokerLabel')
      .then((response) => {
        if (response.data && response.data.length > 0) {
          const brokers = response.data
            .filter((broker) => broker.id && broker.id !== '')
            .map((broker) => ({
              id: broker.id,
              broker: broker.label || `${broker.id} - ${broker.nomefantasia || ''}`
            }));
          setInfosBrokersTemp(brokers);
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as corretoras! Tente novamente.',
          'Atenção'
        );
      });
  };

  const loadPlans = async () => {
    if (!contractType) return;

    try {
      const codcontratotpcontrat = contractType;
      const response = await configAxios.get(`products/getPlansLabel/0/${codcontratotpcontrat}`);

      if (response.data && response.data.length > 0) {
        const plans = response.data
          .filter(
            (plan) =>
              plan.codplano && plan.codplano !== '' && plan.codplano !== null && plan.id !== ''
          )
          .map((plan) => ({
            ...plan,
            label: plan.label || `${plan.codplano} - ${plan.descplano || ''}`,
            displayLabel: `${plan.label || plan.codplano} - ${
              CONTRACT_CODES.find((c) => c.code === contractType)?.label
            }`,
            contract_code: contractType
          }));

        setInfosPlansTemp(plans);
      } else {
        setInfosPlansTemp([]);
      }
    } catch (error) {
      NotificationManager.error(
        'Tivemos dificuldades para buscar os planos! Tente novamente.',
        'Atenção'
      );
      setInfosPlansTemp([]);
    }
  };

  const loadTables = () => {
    if (!infosQuotations.codplano) return;
    configAxios
      .get('/tables/getTablesLabel/0')
      .then((response) => {
        const filteredTables = response.data.filter(
          (table) => table.codplano === infosQuotations.codplano
        );
        setInfosTablesTemp(filteredTables);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as tabelas de referência! Tente novamente.',
          'Atenção'
        );
      });
  };

  const loadRangeValues = () => {
    if (!infosQuotations.codtab) {
      setRangeValues([]);
      return;
    }
    configAxios
      .get(`tables/getRangeValues/${infosQuotations.codtab}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          // Filtrar o item vazio que vem do backend e formatar as faixas
          const formattedRanges = response.data
            .filter((item) => item.label && item.label !== '')
            .map((item) => {
              // Formatar o label: se contém "999", transformar em formato "59+"
              let formattedLabel = item.label;
              if (formattedLabel.includes('999')) {
                const parts = formattedLabel.split(' - ');
                if (parts.length === 2 && parts[1] === '999') {
                  formattedLabel = `${parts[0]}+`;
                }
              }
              return {
                label: formattedLabel,
                valor: item.valor || '0'
              };
            });

          setRangeValues(formattedRanges);

          setBeneficiaries((prev) => {
            const next = {};
            formattedRanges.forEach((range) => {
              next[range.label] = prev[range.label] || '';
            });
            return next;
          });

          if (savedValues.length > 0) {
            setTimeout(() => {
              setBeneficiaries((prev) => {
                const next = { ...prev };
                savedValues.forEach((item) => {
                  if (item.faixa_etaria) {
                    const normalizedFaixa = item.faixa_etaria.trim().replace(/\s+/g, ' ');
                    const matchingRange = formattedRanges.find((range) => {
                      const rangeLabel = range.label.trim();
                      return (
                        rangeLabel === normalizedFaixa ||
                        rangeLabel.replace(/\s+/g, ' ') === normalizedFaixa
                      );
                    });
                    if (matchingRange) {
                      next[matchingRange.label] = item.qtdevidas ? String(item.qtdevidas) : '';
                    }
                  }
                });
                return next;
              });
            }, 100);
          }
        } else {
          setRangeValues([]);
          NotificationManager.warning(
            'Não foram encontradas faixas etárias cadastradas para esta tabela!',
            'Atenção'
          );
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as faixas etárias da tabela! Tente novamente.',
          'Atenção'
        );
        setRangeValues([]);
      });
  };

  const handlePlanChange = (value) => {
    if (!value) {
      setInfosQuotations({
        codplano: '',
        labelplans: '',
        codtab: '',
        labeltables: '',
        contract_code: ''
      });
      return;
    }
    setInfosQuotations((prev) => ({
      ...prev,
      codplano: value.codplano,
      labelplans: value.label,
      contract_code: value.contract_code,
      codtab: '',
      labeltables: ''
    }));
  };

  const handleTableChange = (value) => {
    if (!value) {
      setInfosQuotations((prev) => ({ ...prev, codtab: '', labeltables: '' }));
      return;
    }
    setInfosQuotations((prev) => ({
      ...prev,
      codtab: value.codtab,
      labeltables: value.label
    }));
  };

  function handleInputChange(event) {
    setInfosQuotations({ ...infosQuotations, [event.target.name]: event.target.value });
  }

  const handleBeneficiaryChange = (label, value) => {
    const onlyNumbers = value.replace(/\D/g, '');
    setBeneficiaries((prev) => {
      const next = { ...prev };
      next[label] = onlyNumbers;
      return next;
    });
  };

  const formatCurrency = (value) => {
    const numValue = Number(value);
    if (!Number.isFinite(numValue) || numValue < 0) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(0);
    }
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numValue);
  };

  const handleCoparticipationChange = (event) => {
    const { name, value } = event.target;
    setCoparticipation((prev) => ({ ...prev, [name]: value }));
  };

  const totalBeneficiaries = rangeValues.reduce(
    (sum, range) => sum + Number(beneficiaries[range.label] || 0),
    0
  );

  const mensalidadeBase = calcMensalidadeBase(rangeValues, beneficiaries);
  const {
    valorFinal: mensalidadeFinal,
    descontoTotalPercentual,
    descontoPS,
    descontoInternacao,
    descontoConsultaMedica
  } = calcQuotationDiscounts({
    coparticipation,
    mensalidadeBase,
    totalBeneficiaries,
    abrangenciaPromocional: parseFloat(coveragePromotional) || 0,
    acrescimoValor: parseFloat(coverageAcresc) || 0
  });

  const precoMedio =
    totalBeneficiaries > 0 ? Math.max(0, mensalidadeFinal / totalBeneficiaries) : 0;
  const precoUnico =
    totalBeneficiaries > 0 ? Math.max(0, mensalidadeFinal / totalBeneficiaries) : 0;

  const handleDownloadQuotation = async () => {
    if (!infosQuotations.id) {
      NotificationManager.warning(
        'A cotação precisa ser salva antes de fazer o download!',
        'Atenção'
      );
      return;
    }

    // Fazer download - passar apenas o ID, o backend busca os dados
    configAxios
      .post(
        '/quotations/downloadQuotation',
        {
          ids: [infosQuotations.id]
        },
        { responseType: 'blob' }
      )
      .then((response) => {
        if (response.data.size === 0) {
          NotificationManager.warning('O PDF gerado está vazio!', 'Atenção');
          return;
        }

        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: 'application/pdf' })
        );
        const link = document.createElement('a');
        link.href = url;
        const fileName = infosQuotations.codquotation
          ? `cotacao_${infosQuotations.codquotation}.pdf`
          : `cotacao_${infosQuotations.id}.pdf`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationManager.success('PDF baixado com sucesso!', 'Sucesso');
      })
      .catch((error) => {
        if (error.response?.status === 202) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const text = reader.result;
              const json = JSON.parse(String(text));
              NotificationManager.error(json.Atenção || 'Erro ao gerar o PDF!', 'Atenção');
            } catch (e) {
              NotificationManager.error('Erro ao gerar o PDF!', 'Atenção');
            }
          };
          reader.readAsText(error.response.data);
          return;
        }
        NotificationManager.error(
          error.response?.data?.Atenção ||
            'Tivemos dificuldades para gerar o PDF, tente novamente!',
          'Atenção'
        );
      });
  };

  async function validCNPJ(event) {
    const cnpjValue = event.target.value;

    if (cnpjValue) {
      const cnpjIsValid = validateCNPJ(cnpjValue);
      if (!cnpjIsValid) {
        NotificationManager.warning('CNPJ inválido, por favor verifique!', 'Atenção');
        setInfosQuotations({ ...infosQuotations, cpf_cnpj: '' });
        return;
      }
      setInfosQuotations({ ...infosQuotations, [event.target.name]: cnpjValue });
    }
  }

  function validCPF(event) {
    if (event.target.value) {
      const cpfIsValid = validateCPF(event.target.value);
      if (!cpfIsValid) {
        NotificationManager.warning('CPF inválido, por favor verifique!', 'Atenção');
        setInfosQuotations({ ...infosQuotations, cpf_cnpj: '' });
        return;
      }
      setInfosQuotations({ ...infosQuotations, [event.target.name]: event.target.value });
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    const infosAddEdit = {
      ...infosQuotations,
      contract_code: contractType,
      id_broker: infosQuotations.id_broker || undefined,
      hospital_pronto_socorro: coparticipation.hospital_pronto_socorro || '',
      hospital_internacao: coparticipation.hospital_internacao || '',
      coverage_promotional: coveragePromotional || '',
      acrescimo: coverageAcresc || 0,
      amb_consulta_valor: coparticipation.amb_consulta_valor || '',
      amb_consulta_percent: coparticipation.amb_consulta_percent || '',
      amb_proced_baixo_valor: coparticipation.amb_proced_baixo_valor || '',
      amb_proced_baixo_percent: coparticipation.amb_proced_baixo_percent || '',
      amb_proced_medio_valor: coparticipation.amb_proced_medio_valor || '',
      amb_proced_medio_percent: coparticipation.amb_proced_medio_percent || '',
      amb_proced_alto_valor: coparticipation.amb_proced_alto_valor || '',
      amb_proced_alto_percent: coparticipation.amb_proced_alto_percent || '',
      tpcontrat_client: CONTRACT_CODES.find((c) => c.code === contractType)?.label || contractType,
      id_user: infosQuotations.id_user || infoState.id,
      mensalidade_final: Number(mensalidadeFinal) || 0
    };
    let infosEdit = {};

    infosQuotations.id_user = infosQuotations.id_user ? infosQuotations.id_user : infoState.id;
    infosAddEdit.id_user = infosQuotations.id_user ? infosQuotations.id_user : infoState.id;

    // if (!infosQuotations.id_user) {
    //   NotificationManager.warning('Por favor, selecione um vendedor', 'Atenção');
    //   return;
    // }

    if (infosQuotations.id) {
      const camposManter = [
        'id',
        'codtab',
        'id_user',
        'codplano',
        'contract_code',
        'id_broker',
        'hospital_pronto_socorro',
        'hospital_internacao',
        'coverage_promotional',
        'acrescimo',
        'amb_consulta_valor',
        'amb_consulta_percent',
        'amb_proced_baixo_valor',
        'amb_proced_baixo_percent',
        'amb_proced_medio_valor',
        'amb_proced_medio_percent',
        'amb_proced_alto_valor',
        'amb_proced_alto_percent',
        'tpcontrat_client',
        'mensalidade_final'
      ];
      for (let key in infosAddEdit) {
        if (initialInfosQuotations[key] === infosAddEdit[key]) {
          if (!camposManter.includes(key)) delete infosAddEdit[key];
        }
      }
      infosAddEdit.mensalidade_final = Number(mensalidadeFinal) || 0;
    } else {
      infosAddEdit.mensalidade_final = Number(mensalidadeFinal) || 0;
    }

    // Preparar valores das faixas etárias - salvar TODAS as faixas com preços de venda calculados
    const valuesToSave = rangeValues.map((range) => {
      const qtde = Number(beneficiaries[range.label] || 0);
      const valorFaixa = parseCurrencyValue(range.valor);
      const precoVenda = applyDiscountToPrice(valorFaixa, descontoTotalPercentual);
      let faixa1, faixa2;
      if (range.label.includes('+')) {
        faixa1 = range.label.replace('+', '').trim();
        faixa2 = '999';
      } else {
        const partes = range.label.split('-');
        faixa1 = partes[0].trim();
        faixa2 = partes[1] ? partes[1].trim() : partes[0].trim();
      }

      return {
        id_quotation: infosQuotations.id || 0,
        tpbenef: 'Titular',
        qtdevidas: Number(qtde),
        valquotation: String(valorFaixa.toFixed(2)),
        preco_venda: Number(precoVenda.toFixed(2)),
        faixa_1: Number(parseInt(faixa1, 10)),
        faixa_2: Number(parseInt(faixa2, 10))
      };
    });

    const router = infosQuotations.id ? 'quotations/updateQuotation' : 'quotations/addQuotation';
    const edit = infosQuotations.id ? false : true;

    configAxios
      .post(router, { infosAddEdit, values: valuesToSave })
      .then((response) => {
        NotificationManager.success(
          infosQuotations.id ? 'Cotação atualizada com sucesso!' : 'Cotação realizada com sucesso!',
          'Sucesso'
        );

        if (infosQuotations.id) {
          for (let key in infosAddEdit) {
            if (initialInfosQuotations[key] !== infosAddEdit[key]) {
              initialInfosQuotations[key] = infosAddEdit[key];
            }
          }
          setInfosQuotations({
            ...initialInfosQuotations,
            id: response.data.id,
            labelvend: response.data.labelvend
              ? response.data.labelvend
              : infosQuotations.labelvend,
            datacadastro: response.data.datacadastro
          });

          infosEdit = {
            ...initialInfosQuotations,
            id: infosQuotations.id ? infosQuotations.id : response.data.id
          };
        } else {
          setInfosQuotations({
            ...infosQuotations,
            id: response.data.id,
            labelvend: response.data.labelvend
              ? response.data.labelvend
              : infosQuotations.labelvend,
            datacadastro: response.data.datacadastro
          });

          infosEdit = {
            ...infosQuotations,
            id: infosQuotations.id ? infosQuotations.id : response.data.id
          };
        }

        const quotationId = response.data.id || infosQuotations.id;

        // Recarregar os dados atualizados após salvar
        const reloadAndNavigate = () => {
          configAxios
            .get(`/quotations/listQuotations/?dateinitial=undefined&dateend=undefined`)
            .then((listResponse) => {
              const updatedQuotation = listResponse.data.find((q) => q.id === quotationId);

              if (updatedQuotation) {
                // Atualizar infosEdit com os valores atualizados e todos os dados
                infosEdit = {
                  ...infosEdit,
                  ...updatedQuotation,
                  values: updatedQuotation.values || [],
                  coverage_promotional: updatedQuotation.coverage_promotional || '',
                  hospital_pronto_socorro: updatedQuotation.hospital_pronto_socorro || '',
                  hospital_internacao: updatedQuotation.hospital_internacao || ''
                };
              }

              const nav = `/app/editQuotation/${quotationId}`;
              navigation(nav, {
                state: { infosEdit },
                replace: true
              });
            })
            .catch(() => {
              // Se der erro, navegar mesmo assim
              const nav = `/app/editQuotation/${quotationId}`;
              navigation(nav, {
                state: { infosEdit }
              });
            });
        };

        // Aguardar um pouco para garantir que o banco foi atualizado
        setTimeout(() => {
          if (edit) {
            reloadAndNavigate();
          }
        }, 500);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  };

  return (
    <RenderPage title="Cotação">
      <>
        {isMobile ? (
          <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
            <Grid container>
              <BreadcrumbsNav {...props} />
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="h4" gutterBottom>
                  Modelo de cotação
                </Typography>
                {contractType && (
                  <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 0.5 }}>
                    {CONTRACT_CODES.find((c) => c.code === contractType)?.label || contractType}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2">
                  Escolha o tipo de contratação e informe as quantidades de beneficiários por faixa
                  etária.
                </Typography>
              </Grid>
              {infosQuotations.id && (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownloadQuotation}
                    startIcon={<Iconify icon="eva:cloud-download-outline" />}
                    fullWidth>
                    Download
                  </Button>
                </Grid>
              )}
            </Grid>
          </Stack>
        ) : (
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Grid container>
              <BreadcrumbsNav {...props} />
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="h4" gutterBottom>
                  Modelo de cotação
                </Typography>
                {contractType && (
                  <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 0.5 }}>
                    {CONTRACT_CODES.find((c) => c.code === contractType)?.label || contractType}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2">
                  Escolha o tipo de contratação e informe as quantidades de beneficiários por faixa
                  etária.
                </Typography>
              </Grid>
            </Grid>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              {infosQuotations.id && (
                <>
                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    color="primary"
                    onClick={handleDownloadQuotation}
                    startIcon={<Iconify icon="eva:cloud-download-outline" />}>
                    Download
                  </Button>
                </>
              )}
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/quotation"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            </Stack>
          </Stack>
        )}

        <Card component="form" onSubmit={handleSubmit}>
          <CustomGrid>
            <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 2 }}>
              <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
              <Grid container spacing={2} sx={{ mb: 1 }}>
                {infosQuotations.id && (
                  <Grid item xs={3} md={1} sx={isMobile ? { mt: 1.5 } : { mt: 4.2 }}>
                    <TextField
                      name="id"
                      fullWidth
                      label="ID"
                      variant="outlined"
                      size="small"
                      required
                      disabled
                      value={infosQuotations.id || ''}
                    />
                  </Grid>
                )}
                {infosQuotations.id && initialInfos.codquotation && (
                  <Grid item xs={9} md={2} sx={isMobile ? { mt: 1.5 } : { mt: 4.2 }}>
                    <TextField
                      name="codquotation"
                      fullWidth
                      label="Código da cotação"
                      variant="outlined"
                      size="small"
                      disabled
                      value={initialInfos.codquotation || ''}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={8} sx={{ mb: 2, mt: 2 }}>
                  <TextField
                    name="nome"
                    fullWidth
                    label={contractType === '03' ? 'Nome completo' : 'Razão social'}
                    variant="outlined"
                    size="small"
                    required
                    value={infosQuotations.nome || ''}
                    inputProps={{ maxLength: 48 }}
                    onChange={(event) => handleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12} sx={{ mb: 2, mt: 2 }} md={4}>
                  <InputMask
                    mask={contractType === '03' ? '999.999.999-99' : '99.999.999/0099-99'}
                    value={infosQuotations.cpf_cnpj || ''}
                    onChange={(event) => handleInputChange(event)}
                    onBlur={(event) =>
                      contractType === '03' ? validCPF(event) : validCNPJ(event)
                    }>
                    {() => (
                      <TextField
                        name="cpf_cnpj"
                        fullWidth
                        label={contractType === '03' ? 'CPF' : 'CNPJ'}
                        required
                        variant="outlined"
                        size="small"
                      />
                    )}
                  </InputMask>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <InputLabel id="label" sx={{ fontSize: '13px' }}>
                    Corretora *
                  </InputLabel>
                  <Autocomplete
                    value={
                      infosBrokersTemp.find((broker) => broker.id === infosQuotations.id_broker) ||
                      null
                    }
                    options={infosBrokersTemp}
                    onChange={(_, value) => {
                      setInfosQuotations((prev) => ({
                        ...prev,
                        id_broker: value ? value.id : undefined
                      }));
                    }}
                    getOptionLabel={(option) => option.broker || ''}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={(params) => (
                      <TextField {...params} size="small" placeholder="Selecione" required />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputLabel id="label" sx={{ fontSize: '13px' }}>
                    Tipo de contratação *
                  </InputLabel>
                  <Select
                    fullWidth
                    size="small"
                    value={contractType}
                    onChange={(event) => setContractType(event.target.value)}
                    required>
                    {/* <MenuItem value="">Selecione</MenuItem> */}
                    {CONTRACT_CODES.map((contract) => (
                      <MenuItem key={contract.code} value={contract.code}>
                        {contract.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputLabel id="label" sx={{ fontSize: '13px' }}>
                    Plano de referência *
                  </InputLabel>
                  <Autocomplete
                    value={
                      infosPlansTemp.find((plan) => plan.codplano === infosQuotations.codplano) ||
                      null
                    }
                    options={infosPlansTemp}
                    onChange={(_, value) => handlePlanChange(value)}
                    getOptionLabel={(option) => option.label || ''}
                    isOptionEqualToValue={(option, value) => option.codplano === value.codplano}
                    disabled={!contractType || infosPlansTemp.length === 0}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder="Selecione"
                        required={infosPlansTemp.length > 0}
                        disabled={!contractType || infosPlansTemp.length === 0}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputLabel id="label" sx={{ fontSize: '13px' }}>
                    Tabela de referência *
                  </InputLabel>
                  <Autocomplete
                    value={
                      infosTablesTemp.find((table) => table.codtab === infosQuotations.codtab) ||
                      null
                    }
                    options={infosTablesTemp}
                    onChange={(_, value) => handleTableChange(value)}
                    getOptionLabel={(option) => option.label || ''}
                    isOptionEqualToValue={(option, value) => option.codtab === value.codtab}
                    disabled={!infosQuotations.codplano || infosTablesTemp.length === 0}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder="Selecione"
                        required={infosTablesTemp.length > 0}
                        disabled={!infosQuotations.codplano || infosTablesTemp.length === 0}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                width: '100%',
                mt: 3,
                border: 1,
                borderColor: 'grey.200',
                p: 2,
                overflowX: 'auto'
              }}>
              {rangeValues.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                  Selecione uma tabela para exibir as faixas etárias
                </Typography>
              ) : (
                <>
                  <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                    <Table size="small" aria-label="faixas-etarias">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Faixa Etária</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>
                            Qtd. Beneficiários
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>
                            Tabela Referência
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>
                            Preço de Venda
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rangeValues.map((range) => {
                          const faixaValue = parseCurrencyValue(range.valor);

                          const precoVenda = applyDiscountToPrice(
                            faixaValue,
                            descontoTotalPercentual
                          );

                          return (
                            <TableRow key={`${range.label}-${faixaValue}`}>
                              <TableCell sx={{ fontWeight: 500 }}>{range.label}</TableCell>
                              <TableCell sx={{ width: 140 }}>
                                <TextField
                                  key={`input-${range.label}`}
                                  size="small"
                                  fullWidth
                                  placeholder="0"
                                  value={beneficiaries[range.label] || ''}
                                  onChange={(event) =>
                                    handleBeneficiaryChange(range.label, event.target.value)
                                  }
                                  inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                />
                              </TableCell>
                              <TableCell align="center" sx={{ fontWeight: 500 }}>
                                {formatCurrency(faixaValue)}
                              </TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>
                                {formatCurrency(precoVenda)}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </Box>

            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid item xs={12} md={6}>
                <Box sx={{ border: 1, borderColor: 'grey.200', borderRadius: 1, p: 2 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Coparticipações
                  </Typography>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Hospitalar
                  </Typography>
                  {[
                    { label: 'Pronto Socorro', name: 'hospital_pronto_socorro' },
                    { label: 'Internação', name: 'hospital_internacao' }
                  ].map((row) => (
                    <Grid container spacing={1} alignItems="center" key={row.name} sx={{ mb: 1 }}>
                      <Grid item xs={6}>
                        <Typography variant="body2">{row.label}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          name={row.name}
                          value={coparticipation[row.name]}
                          onChange={handleCoparticipationChange}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">R$</InputAdornment>
                          }}
                        />
                        {row.name === 'hospital_pronto_socorro' && descontoPS > 0 && (
                          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                            Desconto PS: {descontoPS}% aplicado sobre a mensalidade base
                          </Typography>
                        )}
                        {row.name === 'hospital_internacao' && descontoInternacao > 0 && (
                          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                            Desconto: {descontoInternacao}% aplicado sobre a mensalidade base
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                  <Typography variant="subtitle2" sx={{ mb: 1, mt: 2 }}>
                    Abrangência Promocional (%)
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    value={coveragePromotional}
                    onChange={(event) => setCoveragePromotional(event.target.value)}
                    inputProps={{ step: '0.01', min: 0 }}
                    placeholder="Ex: 10"
                  />
                  <Typography variant="subtitle2" sx={{ mb: 1, mt: 2 }}>
                    Valor de acreścimo (%)
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    value={coverageAcresc}
                    onChange={(event) => setCoverageAcresc(event.target.value)}
                    inputProps={{ step: '0.01', min: 0 }}
                    placeholder="Ex: 5"
                  />
                  <Grid container spacing={2} sx={{ mt: 0.5 }}>
                    <Grid item xs={12} md={12}>
                      <InputLabel id="label" sx={{ fontSize: '13px', ml: 0.3 }}>
                        Observações sobre a cotação:
                      </InputLabel>
                      <TextareaAutosize
                        name="obs"
                        label="Observações sobre a cotação:"
                        size="small"
                        variant="outlined"
                        minRows={3}
                        value={infosQuotations.obs || ''}
                        onChange={(event) => handleInputChange(event)}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ border: 1, borderColor: 'grey.200', borderRadius: 1, p: 2 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Ambulatorial
                  </Typography>
                  {[
                    {
                      label: 'Consulta Medica',
                      valorName: 'amb_consulta_valor',
                      percentName: 'amb_consulta_percent',
                      isConsulta: true
                    },
                    {
                      label: 'Procedimento Baixo Custo',
                      valorName: 'amb_proced_baixo_valor',
                      percentName: 'amb_proced_baixo_percent',
                      isConsulta: false
                    },
                    {
                      label: 'Procedimento Médio Custo',
                      valorName: 'amb_proced_medio_valor',
                      percentName: 'amb_proced_medio_percent',
                      isConsulta: false
                    },
                    {
                      label: 'Procedimento Alto Custo',
                      valorName: 'amb_proced_alto_valor',
                      percentName: 'amb_proced_alto_percent',
                      isConsulta: false
                    }
                  ].map((row) => (
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      key={row.valorName}
                      sx={{ mb: 1 }}>
                      <Grid item xs={12}>
                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                          {row.label}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          name={row.valorName}
                          value={coparticipation[row.valorName] || ''}
                          onChange={handleCoparticipationChange}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">R$</InputAdornment>
                          }}
                        />
                        {row.isConsulta && descontoConsultaMedica > 0 && (
                          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                            Desconto Consulta: {descontoConsultaMedica}% aplicado sobre a
                            mensalidade base
                          </Typography>
                        )}
                      </Grid>
                      {!row.isConsulta && (
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            size="small"
                            name={row.percentName}
                            value={coparticipation[row.percentName] || ''}
                            onChange={handleCoparticipationChange}
                            InputProps={{
                              endAdornment: <InputAdornment position="end">%</InputAdornment>
                            }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  ))}
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ mt: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <TextField
                label="Total"
                size="small"
                sx={{ flex: '1 1 150px', minWidth: '120px' }}
                value={totalBeneficiaries}
                disabled
              />
              <TextField
                label="Mens. Base"
                size="small"
                sx={{ flex: '1 1 150px', minWidth: '120px' }}
                value={formatCurrency(mensalidadeBase)}
                disabled
              />
              <TextField
                label="Mens. Final"
                size="small"
                sx={{ flex: '1 1 150px', minWidth: '120px' }}
                value={formatCurrency(mensalidadeFinal)}
                disabled
              />
              <TextField
                label="Preço Médio"
                size="small"
                sx={{ flex: '1 1 150px', minWidth: '120px' }}
                value={formatCurrency(precoMedio)}
                disabled
              />
              <TextField
                label="Preço Único"
                size="small"
                sx={{ flex: '1 1 150px', minWidth: '120px' }}
                value={formatCurrency(precoUnico)}
                disabled
              />
            </Box>

            <Stack direction="row" justifyContent="end" sx={{ mt: 4 }}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                startIcon={<Iconify icon="eva:save-fill" />}
                sx={{ mr: 2 }}>
                Salvar
              </Button>
              <Button
                variant="contained"
                color="error"
                component={RouterLink}
                to="/app/quotation"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Cancelar
              </Button>
            </Stack>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default AddEditQuotation;
